"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringReplacing = exports.formatDate = exports.formatNumber = exports.formatBSB = exports.formatAccountNumber = exports.formatCurrencyHTML = exports.formatCurrency = exports.currencySymbols = void 0;
var index_1 = require("../productcodes/index");
// List of supported currencies, sorted by "name" field not the object literal key
// tslint:disable object-literal-sort-keys
exports.currencySymbols = {
    AUD: { name: 'Australian Dollar', symbol: '$', displayName: 'Australian dollars' },
    CAD: { name: 'Canadian Dollar', symbol: '$', displayName: 'Canadian dollars' },
    CNY: { name: 'Chinese Renminbi', symbol: '¥', displayName: 'Chinese yuan' },
    CZK: { name: 'Czech Koruna', symbol: 'Kč', displayName: 'Czech korunas' },
    DKK: { name: 'Danish Kroner', symbol: 'kr', displayName: 'Danish kroner' },
    EUR: { name: 'Euro', symbol: '€', displayName: 'euro' },
    GBP: { name: 'Great British Pound', symbol: '£', displayName: 'British pounds' },
    HKD: { name: 'Hong Kong Dollar', symbol: '$', displayName: 'Hong Kong dollars' },
    HUF: { name: 'Hungarian Forint', symbol: 'Ft', displayName: 'Hungarian forints' },
    ILS: { name: 'Israeli New Shekel', symbol: '₪', displayName: 'Israeli sheckles' },
    JPY: { name: 'Japanese Yen', symbol: '¥', displayName: 'Japanese yen' },
    NZD: { name: 'New Zealand Dollar', symbol: '$', displayName: 'New Zealand dollars' },
    NOK: { name: 'Norwegian Kroner', symbol: 'kr', displayName: 'Norwegian kroner' },
    PGK: { name: 'Papua New Guinean Kina', symbol: 'K', displayName: 'Papua New Guinean Kina' },
    SGD: { name: 'Singapore Dollar', symbol: '$', displayName: 'Singapore dollars' },
    ZAR: { name: 'South African Rand', symbol: 'R', displayName: 'South African rand' },
    SEK: { name: 'Swedish Kronor', symbol: 'kr', displayName: 'Swedish kronor' },
    CHF: { name: 'Swiss Franc', symbol: '', displayName: 'Swiss francs' },
    THB: { name: 'Thailand Baht', symbol: '฿', displayName: 'Thai baht' },
    AED: { name: 'United Arab Emirates Dirham', symbol: 'د.إ.', displayName: 'UAE dirhams' },
    USD: { name: 'United States Dollar', symbol: '$', displayName: 'US dollars' },
    VND: { name: 'Vietnamese Dong', symbol: '\u20AB', displayName: 'Vietnamese dongs' },
};
// tslint:enable object-literal-sort-keys
/**
 * Formats a number into a currency string
 *
 * @param value. The currency value to format
 * @param currency. AUD, USD, EUR, etc.
 * @param type. symbol: -$1,234.57, code: JPY -¥1,234.57, name: -1,234.57 Chinese yuan
 * @param decimals
 */
exports.formatCurrency = function (value, currency, type, decimals) {
    if (currency === void 0) { currency = 'AUD'; }
    if (type === void 0) { type = 'symbol'; }
    if (decimals === void 0) { decimals = 2; }
    // A number should be passed into this function, but if someone
    // passed a string, attempt to convert string to number.
    if (typeof value === 'string') {
        // Remove anything thats not a numer, hyphen-minus, or decimal point
        var cleaned = String(value).replace(/[^\d\-\.]/g, '');
        // Convert to float. Note: this could return NaN
        value = parseFloat(cleaned);
    }
    // If the input couldn't be converted to a number, or it's a number with
    // value of NaN or Infinity, then return empty string. This should
    // be easier to notice the error over return something like "$0"
    // which looks like a correct value. Also throwing an error mightnt
    // be ideal.
    if (typeof value !== 'number' || isNaN(value) || !isFinite(value)) {
        return '';
    }
    // Japanese and Vietnamese currencies don't have decimals
    if (currency === 'JPY' || currency === 'VND') {
        decimals = 0;
    }
    var currencyString = value
        .toFixed(decimals)
        .split('.')
        .reduce(function (acc, currentValue, index) {
        if (index === 0) {
            return currentValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        else {
            return acc + "." + currentValue;
        }
    }, '');
    if (type === 'symbol' || type === 'code') {
        // Add currency symbol, ie "-2,111,234.58" -> "-$2,111,234.58"
        var currencySymbol = exports.currencySymbols[currency].symbol;
        currencyString = currencySymbol + currencyString.replace('-', '');
        if (value < 0) {
            currencyString = '-' + currencyString;
        }
    }
    if (type === 'code') {
        // Prefix currency code
        currencyString = currency + " " + currencyString;
    }
    if (type === 'name') {
        var currencyName = exports.currencySymbols[currency].displayName;
        currencyString = (currencyString + " " + currencyName).trim();
    }
    if (type === 'name' && currency === 'AUD') {
        // Remove word "Australian" from screenreader copy, so it reads
        // "one dollar" instead of "one Australian dollar"
        currencyString = currencyString.replace('Australian ', '');
    }
    // Remove possible space before numbers
    currencyString = currencyString.replace(/\s(\d)/, '$1');
    return currencyString;
};
/**
 * Returns HTML for displaying currency value
 *
 * @param value
 * @param currency
 * @param type     symbol: -$1,234.57, code: JPY -¥1,234.57
 * @param decimals
 */
exports.formatCurrencyHTML = function (value, currency, type, decimals) {
    if (currency === void 0) { currency = 'AUD'; }
    if (type === void 0) { type = 'symbol'; }
    if (decimals === void 0) { decimals = 2; }
    var display = exports.formatCurrency(value, currency, type, decimals);
    var screenreader = exports.formatCurrency(value, currency, 'name', decimals);
    var html = '';
    html += '<span>';
    html += "<span aria-hidden=\"true\">" + display + "</span>";
    html += "<span class=\"sr-only\">" + screenreader + "</span>";
    html += '</span>';
    return html;
};
var accountNumberFormatters = [{
        // GROUP 1
        // Unmasked: 123-123 1234 1234
        // Masked  : 123-123 XXXX 1234
        formatting: {
            limitGroup: 'End',
            limitGroupSize: 4,
            prefix: 'BSB',
            screenreaderText: 'account',
        },
        productCodes: __spreadArrays(index_1.ProductCodeGroups.DIRECT_ACCOUNTS, index_1.ProductCodeGroups.BANKWEST_TRANSACTION, index_1.ProductCodeGroups.BANKWEST_SAVINGS, index_1.ProductCodeGroups.BANKWEST_DEPOSITS, [
            'LAL',
            'PBA',
            'SIA',
            'SPA',
        ]),
    }, {
        // GROUP 2
        // Unmasked: 1234 1234
        // Masked  : XXXX 1234
        formatting: {
            limitGroup: 'End',
            limitGroupSize: 4,
            prefix: 'None',
            screenreaderText: 'account',
        },
        productCodes: [
            'CFS',
            'LIF',
            'CCP',
        ],
    }, {
        // GROUP 3
        // Unmasked: 123-123 1234 12345
        // Masked  : 123-123 XXXX XX345
        formatting: {
            limitGroup: 'End',
            limitGroupSize: 3,
            prefix: 'BSB',
            screenreaderText: 'account',
        },
        productCodes: [
            'FMS33',
        ],
    }, {
        // GROUP 4
        // Unmasked: HOM 1234 123
        // Masked  : HOM XXX4 123
        formatting: {
            limitGroup: 'End',
            limitGroupSize: 4,
            prefix: 'Policy',
            screenreaderText: 'policy',
        },
        productCodes: __spreadArrays(index_1.ProductCodeGroups.INSURANCE_HOME_CAR, [
            'CIL',
        ]),
    }, {
        // GROUP 5
        // Unmasked: 1234 12
        // Masked  : XXX4 12
        formatting: {
            limitGroup: 'Start',
            limitGroupSize: 3,
            prefix: 'None',
            screenreaderText: 'account',
        },
        productCodes: __spreadArrays(index_1.ProductCodeGroups.COMMSEC_ACCOUNTS),
    }, {
        // GROUP 6
        // Unmasked: 1234 12345
        // Masked  : XXXX X2345
        formatting: {
            limitGroup: 'End',
            limitGroupSize: 4,
            prefix: 'None',
            screenreaderText: 'account',
        },
        productCodes: [
            'RSA',
        ],
    }, {
        // GROUP 7
        // Unmasked: 1234 1234 1234 1234
        // Masked  : XXXX XXXX XXXX 1234
        formatting: {
            limitGroup: 'Start',
            limitGroupSize: 12,
            prefix: 'None',
            screenreaderText: 'card',
        },
        productCodes: __spreadArrays(index_1.ProductCodeGroups.CREDIT_CARDS, index_1.ProductCodeGroups.TRAVEL_MONEY_CARD, index_1.ProductCodeGroups.FINANCIAL_MANAGEMENT_SYSTEM, index_1.ProductCodeGroups.BANKWEST_CREDIT_CARDS),
    }, {
        // GROUP 8
        // Unmasked: 123-123 1234 12345
        // Masked  : 123-123 XXXX X2345
        formatting: {
            limitGroup: 'End',
            limitGroupSize: 4,
            prefix: 'BSB',
            screenreaderText: 'account',
        },
        productCodes: index_1.ProductCodeGroups.LOAN_PRODUCTS,
    }, {
        // GROUP 9
        // Unmasked: AAU 1177 9570 01
        // Masked  : AAU XXXX XXX0 01
        formatting: {
            limitGroup: 'End',
            limitGroupSize: 3,
            prefix: 'Policy',
            screenreaderText: 'agreement',
        },
        productCodes: index_1.ProductCodeGroups.BUSINESS_PRIVATE_BANKING,
    }];
/**
 * Formats account numbers using product code
 *
 * @param accountNumber
 * @param options
 * @param rules
 */
exports.formatAccountNumber = function (accountNumber, options, rules) {
    if (options === void 0) { options = {}; }
    if (rules === void 0) { rules = accountNumberFormatters; }
    // Set default formatting values from options
    var formatter = {
        limitGroup: options.limitGroup || 'End',
        limitGroupSize: options.limitGroupSize || 4,
        mask: options.mask || false,
        prefix: options.prefix || 'None',
        screenreaderText: options.screenreaderText || 'account',
    };
    if (typeof options.productCode !== 'undefined') {
        // Received a product code option
        // The account's product code is used to find the formatter
        var searchString_1 = options.productCode;
        // The Essential Super product is formatted differently to other products with the same product code, so the product subcode is also used to find the formatter.
        if (index_1.ProductCodeGroups.FINANCIAL_MANAGEMENT_SYSTEM.indexOf(options.productCode) !== -1 && options.productSubCode === index_1.ProductSubCodes.ESSENTIAL_SUPER_SUBCODE) {
            searchString_1 += options.productSubCode;
        }
        // Find the rule
        var rule = rules.find(function (frmtr) { return frmtr.productCodes.indexOf(searchString_1) >= 0; });
        if (rule) {
            // A rule was found, copy the formatting values to the formatter object
            if (typeof rule.formatting.limitGroup !== 'undefined') {
                formatter.limitGroup = rule.formatting.limitGroup;
            }
            if (typeof rule.formatting.limitGroupSize !== 'undefined') {
                formatter.limitGroupSize = rule.formatting.limitGroupSize;
            }
            if (typeof rule.formatting.prefix !== 'undefined') {
                formatter.prefix = rule.formatting.prefix;
            }
            if (typeof rule.formatting.screenreaderText !== 'undefined') {
                formatter.screenreaderText = rule.formatting.screenreaderText;
            }
        }
    }
    // The number is masked when requested or when it's already masked (contains an "X")
    var shouldMask = formatter.mask || accountNumber.indexOf('X') !== -1;
    var result = {
        accountNumber: '',
        screenreader: '',
    };
    var chunkAccountNumbers = function (numbers, mask) {
        if (mask) {
            // To mask, account numbers are split into two groups: Start group and End group.
            // The start group is masked, leaving the end group unmasked.
            // A size limit can be specified on one of these groups.
            // This regex will break the account number into two parts
            // with one part containing the number of characters specified
            // in `limitGroupSize`. E.g:
            // limitGroup Start, limitGroupSize 2 = ['12', '345678']
            // limitGroup End, limitGroupSize 2 = ['123456', '78']
            // This allows us to specify that the first x characters should
            // be masked or the last x characters should be unmasked.
            var pattern = formatter.limitGroup === 'Start'
                ? "^(\\w{" + formatter.limitGroupSize + "})(\\w*)$"
                : "^(\\w*)(\\w{" + formatter.limitGroupSize + "})$";
            var regex = new RegExp(pattern);
            var matches = numbers.match(regex);
            if (matches) {
                numbers = matches[1].replace(/\w/g, 'X') + matches[2];
            }
        }
        // Account numbers are split into blocks of 4 digits. If there's
        // one digit remaining it's merged into the previous group.
        // i.e "1234 5678 9" -> "1234 56789"
        var chunked = numbers
            .replace(/(\w{1,4})/g, '$1 ')
            .trim()
            .replace(/\s(\w)$/, '$1');
        return chunked;
    };
    /**
     * To get all screenreaders (Jaws, NVDA, VoiceOver) to read the account number the same
     * way and as a person would speak, the numbers are separated so they're read individually
     * and pauses are included after each chunk of 4-5 digits.
     */
    var accessibleAccountNumber = function (num, mask) {
        var accessibleNumber = num;
        if (mask) {
            // Remove masked characters as the screenreader doesn't read the "X"s
            accessibleNumber = accessibleNumber.replace(/X/g, '');
        }
        else {
            // Add screenreader pause between chunks
            // "1234 5678" -> "1234,5678"
            accessibleNumber = accessibleNumber.replace(/\s/g, ',');
        }
        // Add space after any digit/comma that's not followed by a comma
        // "1234,1234" -> "1 2 3 4, 5 6 7 8"
        accessibleNumber = accessibleNumber.replace(/([\d,])(?!,)/g, '$1 ');
        // Remove double spaces
        accessibleNumber = accessibleNumber.replace(/\s{2,}/g, ' ');
        // Remove whitespace from end of string
        accessibleNumber = accessibleNumber.trim();
        return accessibleNumber;
    };
    if (formatter.prefix === 'BSB') {
        // Format: "123-456"
        var prefix = accountNumber
            .slice(0, 6)
            .replace(/(\w{0,3})(\w{0,3})/, '$1-$2');
        // Format: "1 2 3 dash 4 5 6"
        var accessiblePrefix = prefix
            .replace(/(\d)/g, '$1 ')
            .replace('-', 'dash ')
            .trim();
        var num = chunkAccountNumbers(accountNumber.substr(6), shouldMask);
        result.accountNumber = prefix + "  " + num;
        var accessibleNumber = accessibleAccountNumber(num, shouldMask);
        // Screenreader text
        result.screenreader = 'BSB ';
        result.screenreader += accessiblePrefix;
        result.screenreader += ', ';
        result.screenreader += formatter.screenreaderText;
        result.screenreader += ' number';
        if (shouldMask) {
            result.screenreader += ' ending in';
        }
        result.screenreader += ' ';
        result.screenreader += accessibleNumber;
    }
    else if (formatter.prefix === 'Policy') {
        // Format: MOT/TRV/HOM
        var prefix = accountNumber.slice(0, 3);
        // Format: M O T
        var accessiblePrefix = prefix
            .replace(/(\w)/g, '$1 ')
            .trim();
        var num = chunkAccountNumbers(accountNumber.slice(3), shouldMask);
        result.accountNumber = prefix + " " + num;
        var accessibleNumber = accessibleAccountNumber(num, shouldMask);
        // Screenreader text
        result.screenreader = accessiblePrefix;
        result.screenreader += ' ';
        result.screenreader += formatter.screenreaderText;
        result.screenreader += ' number';
        if (shouldMask) {
            result.screenreader += ' ending in';
        }
        result.screenreader += ' ';
        result.screenreader += accessibleNumber;
    }
    else {
        var num = chunkAccountNumbers(accountNumber, shouldMask);
        result.accountNumber = num;
        var accessibleNumber = accessibleAccountNumber(num, shouldMask);
        // Screenreader text
        result.screenreader += formatter.screenreaderText;
        result.screenreader += ' number';
        if (shouldMask) {
            result.screenreader += ' ending in';
        }
        result.screenreader += ' ';
        result.screenreader += accessibleNumber;
    }
    return result;
};
/**
 * Format a BSB number
 *
 * The function should work while a user is typing, so it shouldn't remove
 * formatting if they add it, i.e user types "123-", it shouldn't be reduced
 * to "123".
 *
 * @param input
 */
exports.formatBSB = function (input) {
    if (typeof input !== 'string') {
        return '';
    }
    // Remove anything thats not a number
    var numbers = String(input).replace(/[^\d]/g, '');
    if (numbers.length === 0) {
        return '';
    }
    // Don't format more than 6 characters
    if (numbers.length > 6) {
        numbers = numbers.slice(0, 6);
    }
    // Split into groups of 3 characters
    var matches = numbers.match(/(\d){1,3}/g);
    if (matches === null) {
        /* istanbul ignore next */
        return '';
    }
    // Join with hyphen-minus
    numbers = matches.join('-');
    // If the user adds their own formatting, allow it to remain.
    // i.e '123-' would normally be reduced to '123'
    if (numbers.length === input.length - 1 && input.slice(-1) === '-') {
        numbers += '-';
    }
    return numbers;
};
/**
 * Format a number
 * Note: this is not used for currency
 * @param input
 */
exports.formatNumber = function (input) {
    if (typeof input === 'number') {
        /* istanbul ignore next */
        input = String(input);
    }
    // Remove anything thats not a number, negative, or decimal
    var numberString = input.replace(/[^\d\-\.]/g, '');
    if (numberString === '') {
        return '';
    }
    // Separate the integer part of the number from the fractional part
    // Regex explanation:
    // - Optional group that may contain a negative before a number
    // - Optional decimal
    // - Followed by up to 2 numbers
    var matches = numberString.match(/^(-?\d*)?(\.)?(\d{1,2})?/);
    if (matches === null) {
        /* istanbul ignore next */
        return '';
    }
    // Convert integer part of number to float
    // The integer part can only contain 9 characters
    var float = parseFloat(matches[1].slice(0, 9));
    if (isNaN(float)) {
        return '';
    }
    // Convert float to string and add grouping separator
    var formatted = float.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Add decimal point
    if (typeof matches[2] !== 'undefined') {
        formatted += '.';
    }
    // Add unformatted fractional part of the number
    if (typeof matches[3] !== 'undefined') {
        formatted += matches[3];
        if (matches[3].length === 1) {
            formatted += '0';
        }
    }
    return formatted;
};
/**
 * Format a date string
 *
 * @param value
 * @param inputFormat
 * @param outputFormat
 */
exports.formatDate = function (value, inputFormat, outputFormat) {
    if (inputFormat === void 0) { inputFormat = 'YYYY-MM-DD'; }
    if (outputFormat === void 0) { outputFormat = 'DD/MM/YYYY'; }
    var year = '';
    var month = '';
    var day = '';
    // Extract the year, month, and day from the input string
    if (inputFormat === 'YYYY-MM-DD') {
        var matches = value.match(/^(\d{4,4})-(\d{2,2})-(\d{2,2})$/);
        if (matches !== null) {
            year = matches[1];
            month = matches[2];
            day = matches[3];
        }
    }
    else if (inputFormat === 'DD/MM/YYYY') {
        var matches = value.match(/^(\d{2,2})\/(\d{2,2})\/(\d{4,4})$/);
        if (matches !== null) {
            year = matches[3];
            month = matches[2];
            day = matches[1];
        }
    }
    if (year === '') {
        // Unknown input format, or value didn't match pattern
        return value;
    }
    if (outputFormat === 'DD/MM/YYYY') {
        return day + "/" + month + "/" + year;
    }
    else if (outputFormat === 'YYYY-MM-DD') {
        return year + "-" + month + "-" + day;
    }
    // Unknown output format
    return value;
};
/**
 * Replacing {n} with needed data
 *
 * @param str
 * @param args
 */
exports.stringReplacing = function (str) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var newStr = str || '';
    var replaceFn = function (mtch, num) { return (typeof args[num] !== 'undefined' ? args[num] : mtch); };
    return newStr.replace(/{(\d+)}/g, replaceFn);
};
